import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[tusangairePhoneNumberLength]'
})
export class PhoneNumberLengthDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string):void {
    // Remove any non-numeric characters
    const sanitizedValue = value.replace(/\D/g, '');
    
    // Check if the input length is within the valid range (7-15)
    if (sanitizedValue.length > 15) {
      this.ngControl.control?.setValue(sanitizedValue.slice(0, 15));
    } else if (sanitizedValue.length < 7 && sanitizedValue.length > 0) {
      this.ngControl.control?.setErrors({ minLength: true });
    } else {
      this.ngControl.control?.setErrors(null);
    }
  }
}
